import { boolean, date, object, string } from "yup";
import { ExternalPatientLinkSchema } from "./externalPatientLink.js";
/**
 * A yup schema for a link to a External Patient Record on an External System.
 */
export const ExternalPatientLinkEnhancedSchema = ExternalPatientLinkSchema.concat(object({
    externalSystemDisplayName: string().optional(),
    dateLastProcessed: date().optional(),
    canPull: boolean().required(),
    canPush: boolean().required(),
}));
// We cannot use yup to infer as it doesn't work for tsoa.
// export type ExternalPatientLinkEnhanced = InferType<typeof ExternalPatientLinkEnhancedSchema>;
// But we can use ObjectSchema<> to ensure they largely stay in sync
//# sourceMappingURL=externalPatientLinkEnhanced.js.map